import { cx, useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { CountryDetails } from "./types";

export interface CountriesTableProps {
  rows: CountryDetails[];
  activeCountryKey: string | null;
  onActiveCountryKeyChange: (countryKey: string | null) => void;
}

export const CountriesTable: FC<CountriesTableProps> = ({
  rows,
  activeCountryKey,
  onActiveCountryKeyChange,
}) => {
  const { t } = useTranslations();

  return (
    <table className="w-full table-fixed border-collapse">
      <colgroup>
        <col className="w-[75%]" />
        <col className="w-[25%]" />
      </colgroup>
      <thead>
        <tr>
          <th className="sticky top-0 z-10 min-w-0 border-0 border-t-0 border-r border-b border-l-0 border-solid border-[#F3F2F3] bg-white px-4 py-3 text-left font-secondary text-xs text-dark-700">
            {t({ id: "common.country", defaultMessage: "Country" })}
          </th>
          <th className="sticky top-0 z-10 border-0 border-t-0 border-r-0 border-b border-l-0 border-solid border-[#F3F2F3] bg-white px-4 py-3 text-center font-secondary text-xs text-dark-700">
            {t({ id: "common.sessions", defaultMessage: "Sessions" })}
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => {
          const isActive = activeCountryKey === row.countryKey;

          return (
            <tr
              key={row.countryKey}
              className={cx("transition-colors", isActive && "bg-grey-100")}
              onMouseEnter={() => onActiveCountryKeyChange(row.countryKey)}
              onMouseLeave={() => onActiveCountryKeyChange(null)}
            >
              <td className="min-w-0 border-0 border-t-0 border-r border-b border-l-0 border-solid border-[#F3F2F3] px-4 py-5 text-left font-secondary text-sm font-medium text-dark">
                <div className="flex items-center gap-3">
                  <span
                    className="h-[10px] w-[10px] shrink-0 rounded-full"
                    style={{ backgroundColor: row.countryColor }}
                  />
                  <span className="truncate" title={row.countryName}>
                    {row.countryName}
                  </span>
                </div>
              </td>
              <td className="border-0 border-t-0 border-r-0 border-b border-l-0 border-solid border-[#F3F2F3] px-4 py-5 text-center font-secondary text-sm text-dark">
                {row.chatsCount}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
